'use strict';
export default function CurrentPartnerService($http, $q, $location) {
  var partner = null;

  return {
    get: get
  };

  function get() {
    return $q.resolve().then(function() {
      if (partner) {
        return partner;
      }

      return _get().then(function(response) {
        partner = response.data.partner;
        return partner;
      });
    });
  }

  function _get() {
    var url = '/partners/current';
    var partnerQueryParam = $location.search().subdomain;

    if (partnerQueryParam) {
      url += '?subdomain=' + partnerQueryParam;
    }

    return $http.get(url);
  }
}

CurrentPartnerService.$inject = ['$http', '$q', '$location'];
